/**
 * /admin/console — placeholder route.
 *
 * The Admin Console initiative (curators, logs, roles, API keys) is forthcoming.
 * This route makes the dropdown item + G A shortcut functional so super-admins
 * can discover the surface. Full implementation deferred to T-CONSOLE-PHASE.
 */
import { BilingualHeading } from '@repo/ui/components/BilingualHeading';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/console')({
  component: ConsolePlaceholderPage,
});

function ConsolePlaceholderPage() {
  return (
    <main className="flex-1 flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-sm">
        <BilingualHeading
          bn="অ্যাডমিন কনসোল শীঘ্রই আসছে"
          en="ADMIN CONSOLE — COMING SOON"
          as="h1"
          size="lg"
        />
        <p lang="bn" className="mt-4 text-[14px] font-sans text-ink-dim leading-relaxed">
          কিউরেটর ব্যবস্থাপনা, লগ পর্যবেক্ষণ, ভূমিকা কনফিগারেশন এবং API কী ব্যবস্থাপনা শীঘ্রই এখানে পাওয়া যাবে।
        </p>
        <p
          aria-hidden="true"
          className="mt-2 font-mono text-[10px] text-ink-mute uppercase tracking-[0.16em]"
        >
          CURATORS · LOGS · ROLES · API KEYS
        </p>
      </div>
    </main>
  );
}
